import { useEffect, useState } from "react";

import { useValidateReferralCode } from "@jti/rest-api";

export type UserReferralCodeValidationState = {
  isIdle: boolean;
  isValid: boolean | undefined;
  isPending: boolean;
  isReferralCodeActive: boolean;
  handleCodeValidation: () => Promise<boolean>;
  handleToggleIsReferralCodeActive: () => void;
};

export const useReferralCode = (referralCode: string): UserReferralCodeValidationState => {
  const [isReferralCodeActive, setIsReferralCodeActive] = useState(false);

  const { data: isValid, reset, isIdle, isLoading, handleCodeValidation } = useValidateReferralCode(referralCode);

  const handleToggleIsReferralCodeActive = () => {
    setIsReferralCodeActive((isActive) => !isActive);
  };

  useEffect(() => {
    reset();
  }, [referralCode]);

  useEffect(() => {
    if (referralCode) {
      setIsReferralCodeActive(true);
    }
  }, []);

  return {
    isIdle,
    isValid,
    isPending: isLoading,
    isReferralCodeActive,
    handleCodeValidation,
    handleToggleIsReferralCodeActive,
  };
};
